import {useDispatch, useSelector} from 'react-redux';
import {useCallback} from 'react';
import {fetchMortgagePartnerProduct} from '@Root/slices/myhouse/mortgageLoanSlice';
import {RootState} from '@Root/slices';
import {MORTGAGE_PARTNER_PRODUCT_TYPE} from '@Root/contants/myhouse';

export default function useMortgageLoan() {
    const dispatch = useDispatch();
    const reduxMortgageLoan = useSelector((state: RootState) => state.mortgageLoan);

    const loadMortgagePartnerProduct = useCallback(() => {
        dispatch(
            fetchMortgagePartnerProduct({
                productTypes: [MORTGAGE_PARTNER_PRODUCT_TYPE.전월세_신규],
            })
        );
    }, [dispatch]);

    return {
        loadMortgagePartnerProduct,
        reduxMortgageLoan,
    };
}
